import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from '@common/services/ModalService/ModalService';

@Component({
  templateUrl: './passwordResetConfirmView.component.html',
  styleUrls: ['./passwordResetConfirmView.component.scss'],
})
export class PasswordResetConfirmViewComponent implements OnInit {
  passwordResetConfirmForm: FormGroup;
  attemptedToSubmit = false;
  submitted = false;
  uid: string;
  token: string;

  constructor(
    public authService: AuthService,
    public router: Router,
    public route: ActivatedRoute,
    public modalService: ModalService,
  ) {}

  ngOnInit() {
    this.passwordResetConfirmForm = new FormGroup(
      {
        newPassword: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          this.tooSimple,
          this.entirelyNumeric,
        ]),
        confirmPassword: new FormControl('', [
          Validators.required,
        ]),
      },
      this.doNotMatch,
    );

    this.route.params.subscribe((params) => {
      this.uid = params['uid'];
      this.token = params['token'];
    });
  }

  tooSimple(formControl: FormControl) {
    const error = {
      passwordTooSimple: true,
    };

    return formControl.value.match(/^(.)\1*$/gi) ? error : null;
  }

  entirelyNumeric(formControl: FormControl) {
    const error = {
      passwordEntirelyNumeric: true,
    };
    return formControl.value.match(/^\d+$/gi) ? error : null;
  }

  doNotMatch(formGroup: FormGroup) {
    const error = {
      passwordsDoNotMatch: true,
    };

    return (formGroup.value.newPassword !== formGroup.value.confirmPassword) ? error : null;
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.attemptedToSubmit = true;

    if (this.passwordResetConfirmForm.valid) {
      this.authService.confirmPasswordReset({
        uid: this.uid,
        token: this.token,
        new_password: this.passwordResetConfirmForm.get('newPassword').value,
      })
        .subscribe(
          (res) => {
            this.router.navigateByUrl('/dashboard');
            this.modalService.openModal({ type: 'passwordChanged' });
          },
          (err) => {
            this.modalService.openModal({ type: 'errorOccurred' });
            this.submitted = false;
          },
        );

      this.submitted = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/views/PasswordResetConfirmView/passwordResetConfirmView.component.ts